/* eslint-disable linebreak-style */
import { createContext } from 'react';

const ApplicationContext = createContext({});
export default ApplicationContext;
